import AbstractValidator from '@vertical-plus/vue-js-core/dist/model/validator/abstract-validator';
export default class AbstractMappingValidator extends AbstractValidator {
    validateValueSettings(valueSettings, validationErrors) {
        const errors = [];
        if (!valueSettings) {
            return errors;
        }
        if ('value' in valueSettings && typeof valueSettings.value !== 'string') {
            errors.push(this.i18n.t('mapping.validation.please_enter_value').toString());
        }
        else if ('valueRuleId' in valueSettings && !valueSettings.valueRuleId) {
            errors.push(this.i18n.t('mapping.validation.please_add_rule').toString());
        }
        else if ('valueColumn' in valueSettings && !valueSettings.valueColumn) {
            errors.push(this.i18n.t('mapping.validation.please_select_column').toString());
        }
        return errors;
    }
}
//# sourceMappingURL=abstract-mapping-validator.js.map